// リスクアセスメントの各エンドポイントは counselor / operator / high_risk / developer のみ許可される（api-endpoints.md RBAC）。
// 許可されないロールで呼ぶと 403 になり、共通インターセプタがスナックバー表示とホームへの強制遷移を行ってしまう。
// カルテを開いた時点で status を呼ぶため、フロント側でも同じ条件で事前に判定する。
const ALLOWED_CAPABILITIES = ["counselor:access", "operator:access", "high_risk:access", "developer:access"];

export const canUseRiskAssessment = (capabilities: readonly string[] | null | undefined): boolean =>
  ALLOWED_CAPABILITIES.some((capability) => (capabilities ?? []).includes(capability));
